import { useCallback, useEffect, useRef, useState, type CSSProperties } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { H5BackButton } from "../../components/common/H5BackButton";
import { h5BackButtonCssVars } from "../../components/common/H5BackButtonConfig";
import { spaceHomeSubPageShellCssVars } from "../home/Config";
import { globalModel } from "../../global/GlobalModel";
import { h5NavigateTo } from "../../utils/miniProgramEnv";
import { useSafeAreaTopPad } from "../../utils/useSafeAreaTopPad";
import { SpaceCustomerServicePage } from "../customer-service/SpaceCustomerServicePage";
import { SpaceCustomerServiceApi } from "../customer-service/SpaceCustomerServiceApi";
import { SpaceMessageCenterApi } from "./SpaceMessageCenterApi";
import "./SpaceMessagesStyle.css";

/** 消息中心 · 服务专员聊天（全屏，无底部 Tab） */
export const SpaceMessageCsChatPage = observer(function SpaceMessageCsChatPage() {
  const { spaceId } = useParams<{ spaceId: string }>();
  const navigate = useNavigate();
  const headerRef = useRef<HTMLElement>(null);
  const topPad = useSafeAreaTopPad(headerRef);
  const sid = spaceId?.trim() ?? "";
  const [title, setTitle] = useState("服务专员");

  useEffect(() => {
    if (!sid) return;
    void SpaceCustomerServiceApi.getSpaceCsEntryConfig(sid).then((res) => {
      setTitle(res.entryDisplayName?.trim() || "服务专员");
    });
  }, [sid]);

  useEffect(() => {
    if (!sid || !globalModel.isLoggedIn) return;
    void SpaceMessageCenterApi.markRead(sid, "cs");
  }, [sid]);

  const onBack = useCallback(() => {
    if (!sid) {
      navigate(-1);
      return;
    }
    h5NavigateTo(navigate, `/space/${sid}/messages`, { replace: true });
  }, [navigate, sid]);

  if (!sid || !/^\d{8}$/.test(sid)) {
    return null;
  }

  const navStyle: CSSProperties | undefined =
    topPad > 0
      ? ({ "--space-message-chat-nav-safe-top-pad": `${topPad}px` } as CSSProperties)
      : undefined;

  return (
    <div
      className="space-message-chat-shell"
      style={{ ...h5BackButtonCssVars(), ...spaceHomeSubPageShellCssVars() }}
    >
      <header ref={headerRef} className="space-message-chat-shell__nav" style={navStyle}>
        <div className="space-message-chat-shell__nav-side space-message-chat-shell__nav-side--left">
          <H5BackButton
            className="space-message-chat-shell__back"
            iconClassName="h5-back-button__icon h5-back-button__icon--invert"
            onClick={onBack}
          />
        </div>
        <h1 className="space-message-chat-shell__title">{title}</h1>
        <div className="space-message-chat-shell__nav-side" aria-hidden />
      </header>
      <div className="space-message-chat-shell__main">
        <SpaceCustomerServicePage spaceId={sid} embedded onUnreadChange={() => {}} />
      </div>
    </div>
  );
});

export default SpaceMessageCsChatPage;
